// Revise run — paper-profile chrome: timer chips and the skills coach.
//
// Timers are a guide, not a penalty (both authors' framing). The THIS Q chip
// restarts on every question, freezes grey once the question is answered, and
// colours green → amber → red against the recommended time.

import { useState } from 'react';
import type { NscSkill, QuestionScreen, ReviseRun } from '../../../../../lib/revise/types';
import { SOURCE_EXAM_COACHING } from '../scenario/sourceExamCoaching';
import { html } from './ContentScreens';

export function fmt(sec: number): string {
  const m = Math.floor(Math.abs(sec) / 60);
  const s = Math.abs(sec) % 60;
  return `${sec < 0 ? '+' : ''}${m}:${String(s).padStart(2, '0')}`;
}

export function TimerChips({ q, qSeconds, totalSeconds, recommended, answered, timedMinutes }: { q: QuestionScreen | null; qSeconds: number; totalSeconds: number; recommended: number; answered: boolean; timedMinutes?: number }) {
  const left = recommended - qSeconds;
  const cls = answered ? 'rr-timer-done' : left < 0 ? 'rr-timer-over' : left <= recommended * 0.25 ? 'rr-timer-warn' : 'rr-timer-ok';
  return (
    <span className="rr-chips" aria-live="off">
      {q && (
        <span className={`rr-chip ${cls}`} title="Recommended time for this question. A guide, not a penalty.">
          This Q {fmt(answered ? qSeconds : left)}
        </span>
      )}
      <span className="rr-chip" title={timedMinutes ? `About ${timedMinutes} minutes for the paper.` : 'Time on the paper so far.'}>
        Total {fmt(totalSeconds)}
      </span>
    </span>
  );
}

export function CoachButton({ skill, run }: { skill: NscSkill; run: ReviseRun }) {
  const [open, setOpen] = useState(false);
  const guide = SOURCE_EXAM_COACHING[skill];
  const example = run.paper?.guideExamples?.[skill];
  return (
    <>
      <div>
        <button type="button" className="rr-coach-btn" onClick={() => setOpen(true)}>
          <span className="rr-coach-icon" aria-hidden>
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.6 10.8c.6.5 1 1.2 1 2V16h5.2v-.2c0-.8.4-1.5 1-2A6 6 0 0 0 12 3z" />
            </svg>
          </span>
          {guide.buttonText}
        </button>
      </div>
      {open && (
        <div className="rr-modal" role="dialog" aria-modal="true" aria-label={guide.title} onClick={() => setOpen(false)}>
          <div className="rr-modal-card" onClick={(e) => e.stopPropagation()}>
            <span className="rr-eyebrow">Skills guide</span>
            <h2>{guide.title}</h2>
            <h3>{guide.sub}</h3>
            <div className="rr-rich" {...html(guide.intro)} />
            <ol>
              {guide.steps.map((s, i) => (
                <li key={i}>
                  <b>{s[0]}</b> {s[1]}
                </li>
              ))}
            </ol>
            <div className="rr-guide-example rr-rich">
              <b>Example. </b>
              <span {...html(example ?? guide.example)} />
            </div>
            <div className="rr-guide-warn rr-rich">
              <b>Common mistakes. </b>
              <span {...html(guide.warn)} />
            </div>
            <div>
              <button type="button" className="rr-btn-primary" onClick={() => setOpen(false)}>
                Back to the question
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
